import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import bannerBg from '../assets/img/page-banner.jpg';
import { getServiceBySlug } from '../data/servicesData';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';

function ServicesDetails() {
    const { serviceName } = useParams();
    const service = getServiceBySlug(serviceName);

    if (!service) {
        return <Redirect to="/servicii" />;
    }

    return (
        <>
            <Helmet>
                <title>{service.metaTitle}</title>
                <meta name="description" content={service.metaDescription} />
                <meta name="keywords" content={service.keywords} />
            </Helmet>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                heading={service.title}
                currentPage={service.title}
            />
            <section className="service-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ServiceSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="service-details-content">
                                <div
                                    className="service-main-thumb bg-cover mb-40"
                                    style={{ backgroundImage: `url(${service.thumbnail})`, height: '400px' }}
                                />
                                <div
                                    className="service-details-text"
                                    dangerouslySetInnerHTML={{ __html: service.fullDescription }}
                                />
                                <div className="cta-card mt-40" style={{background: '#f8f9fa', padding: '30px', borderRadius: '8px'}}>
                                    <h3>Solicită o Ofertă Personalizată</h3>
                                    <p>Contactează-ne pentru mai multe detalii despre {service.title} și pentru o evaluare gratuită a proiectului tău.</p>
                                    <a href="/contact" className="theme-btn">Contactează-ne Acum</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default ServicesDetails;
